import { useContext } from 'react';

import { login, logout, verifyMfa } from '@features/authentication/utilities/authentication';

import AuthContext from '@features/authentication/context/authentication';

import { AuthenticationStatus, AuthError } from '../types/authentication';

interface useAuthenticationReturnValue {
    status?: AuthenticationStatus;
    errors?: AuthError[];
    login: ReturnType<typeof login>;
    logout: ReturnType<typeof logout>;
    verifyMfa: ReturnType<typeof verifyMfa>;
    cancelMfa: () => void;
}

const useAuthentication = (): useAuthenticationReturnValue => {
    const { status, errors, setAuthState } = useContext(AuthContext);

    return {
        status,
        errors,
        login: login(setAuthState),
        logout: logout(setAuthState),
        verifyMfa: verifyMfa(setAuthState),
        cancelMfa: () => setAuthState({ status: 'Unauthorized' }),
    };
};

export default useAuthentication;
